export default __webpack_public_path__ + "static/media/Rollin_at_5.1eb43601.mp3";